// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xorc","content":"styles_content__3Efv8","tableWrap":"styles_tableWrap__1V5kC"};